/**
 * Created by dorin on 6/22/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import cookie from 'react-cookies';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class Login extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      referrerId: null,
      email: '',
      password: '',
    };
  }

  componentDidMount() {
    const referrerId = cookie.load('referrerId');
    if (referrerId) {
      this.setState({ referrerId });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { isAuthenticated, status, error, router, location, dispatch } =
      nextProps;

    if (isAuthenticated) {
      dispatch(actions.getProfile());
      dispatch(actions.getSubscription());
      dispatch(actions.getRoles());
      dispatch(actions.getOwnershipTypes());
      dispatch(actions.getContractBlocks());
      dispatch(actions.getWorkTypes());
      dispatch(actions.getSubWorkTypes());

      const redirectRoute = location.query.next || '/';
      router.push(redirectRoute);
    } else if (status === actionTypes.AUTH_LOGIN_ERROR) {
      if (error) {
        const errors = Object.values(error);
        errors.forEach((e) => dispatch(actions.alert('error', e[0])));
      } else {
        dispatch(
          actions.alert(
            'error',
            'Wrong username and password. Please try again.'
          )
        );
      }
    }
  }

  login(e) {
    e.preventDefault();

    const { dispatch } = this.props;
    const { email, password } = this.state;

    dispatch(actions.hideAlert());

    if (email !== '' && password !== '') {
      dispatch(actions.login(email, password));
    }
  }

  handleChange = (type, e) => {
    this.setState({ [type]: e.target.value });
  };

  render() {
    const { status } = this.props;
    const { referrerId, email, password } = this.state;

    return (
      <div className="login">
        <h3 className="title">Sign in to Cosynd</h3>

        <Form onSubmit={(e) => this.login(e)}>
          <FormGroup>
            <FormControl
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => this.handleChange('email', e)}
              autoFocus
              required
            />
          </FormGroup>
          <FormGroup>
            <FormControl
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => this.handleChange('password', e)}
              required
            />
          </FormGroup>
          <hr className="transparent" />
          <FormGroup className="actions login-actions">
            <div>
              {referrerId ? (
                <Link to={`/signup/ref/${referrerId}`}>Sign up here</Link>
              ) : (
                <Link to="/signup">Sign up here</Link>
              )}
              <hr className="transparent" />
              <Link to="/forgot-password">Forgot your password?</Link>
              <hr className="transparent" />
              <Link to="/resend-verification-link">
                Verify your email address
              </Link>
            </div>
            <div>
              <button
                type="submit"
                disabled={status === actionTypes.AUTH_LOGIN_REQUEST}
              >
                {status === actionTypes.AUTH_LOGIN_REQUEST && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                sign in
              </button>
            </div>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  status: state.auth.status,
  error: state.auth.error,
});

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// src/components/Auth/Login.jsx